import { ParameterType } from '../../types';

export const getEditorForType = (type: ParameterType) => {
  switch (type) {
    case 'DropDownList':
    case 'RadioButton':
      return 'select';
    case 'DateBox':
      return 'date';
    default:
      return 'text';
  }
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/getEditorForType.ts